module.exports = __webpack_public_path__ + "static/img/gongYIGuoCheng_details.1393b479.jpg";